module.exports = __webpack_public_path__ + "static/logo-white-86c153eeed0a844c24035eb6bde13ba5.svg";